var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.8 86.1",
    style: {
      enableBackground: "new 0 0 85.8 86.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);stroke:#818082;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:#818082;}\n\t.st2{font-family:'Montserrat-SemiBold';}\n\t.st3{font-size:28px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.0622,
    y1: -140.3146,
    x2: 490.177,
    y2: -140.3146,
    gradientTransform: "matrix(0.7226 -0.6913 0.6913 0.7226 -183.6722 454.0333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFD1D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#C9CBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#B9BBBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#9EA0A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E9092"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.8,17.3c-0.4-0.9-1.5-1.2-2.4-0.7c-0.1,0-0.2,0.1-0.3,0.2L70,19c-1.2,0.6-2.2,0.4-3.1-0.5l-0.2-0.2 c-2.3-1.9-4.7-3.7-7.2-5.6l1.4-6.1c0.4-1.4,0.1-2.1-1.2-2.7c-3.1-1.3-6.4-2.3-9.7-2.8c-0.6-0.1-1.2-0.1-1.8,0 c-0.8,0-1.5,0.6-1.7,1.4c-0.6,2.1-1.4,4.2-2,6.1L33.2,10c-1-1.7-2.2-3.7-3.4-5.6c-0.4-0.9-1.4-1.3-2.3-0.9c0,0,0,0-0.1,0 c-3.5,1.4-6.9,3.3-9.9,5.6c-0.9,0.5-1.2,1.7-0.7,2.6c0,0,0,0.1,0,0.1c0.9,1.8,1.7,3.6,2.7,5.3c0.3,0.4,0.3,1-0.1,1.3 c0,0-0.1,0.1-0.1,0.1c-0.6,0.5-1.2,1.2-1.7,1.8c-1.6,2-3.1,4.1-4.7,6.3C10.7,26,8.5,25.5,6.3,25c-1-0.2-1.7,0-2,0.8 C2.7,29.5,1.6,33.3,1,37.2c-0.2,1,0.5,2,1.5,2.2c0.9,0.3,1.8,0.6,2.8,0.9c1.3,0.4,2.5,0.9,3.8,1.2c-0.1,3.4,0.2,6.8,1.1,10.1 c0.2,0.5,0,1.1-0.5,1.4l0,0c-1.7,1-3.3,2-4.9,3.1c-1.2,0.8-1.5,1.5-0.9,2.8c1.3,2.7,2.7,5.3,4.2,7.9c0.5,0.8,1,1.4,1.7,2.1 c0.6,0.7,1.6,0.8,2.4,0.3c1.7-0.9,3.5-1.8,5.3-2.7c0.4-0.2,0.8-0.2,1.1,0.2c0,0,0,0,0,0c0.5,0.6,1.1,1.2,1.7,1.7 c2.1,1.7,4.3,3.3,6.5,4.9l-1.5,6.4c-0.4,0.9,0,1.9,0.8,2.3c0.1,0,0.2,0.1,0.3,0.1c3.4,1.5,7,2.5,10.7,3c1,0.3,2-0.2,2.4-1.2 c0-0.1,0.1-0.2,0.1-0.3c0.6-1.9,1.3-3.8,1.9-5.7c0-0.4,0.4-0.7,0.8-0.6h0c3.3,0.1,6.6-0.3,9.7-1.2c0.4-0.2,0.8,0,1,0.4 c1.1,1.8,2.3,3.6,3.4,5.3c0.4,0.8,1.4,1.2,2.3,0.8h0c3.5-1.4,6.8-3.3,9.8-5.6c0.9-0.5,1.3-1.6,0.8-2.5c-0.1-0.1-0.1-0.2-0.2-0.3 c-0.9-1.7-1.8-3.5-2.7-5.2c-0.2-0.3-0.1-0.9,0.1-1.1c2.5-2.5,4.7-5.3,6.4-8.3l1.7,0.3c1.7,0.4,3.4,0.8,5.1,1.1 c0.9,0.3,1.9-0.1,2.2-1c0.1-0.1,0.1-0.3,0.1-0.4c0.8-2.1,1.5-4.2,2.1-6.4c0.4-1.5,0.6-3,0.7-4.5c0.1-1.2-0.4-1.7-1.6-2.1 c-1.9-0.6-3.7-1.2-5.6-1.8c-0.3-0.1-0.6-0.3-0.6-0.7c0-3.3-0.4-6.7-1.2-9.9c0-0.3,0.1-0.6,0.3-0.8c1.7-1.1,3.4-2.2,5.1-3.2 c1.2-0.7,1.5-1.5,0.9-2.7c-1-2.1-2-4.1-3.1-6.1C78.4,19.7,77.7,18.5,76.8,17.3L76.8,17.3L76.8,17.3z M55.5,64.9 c-12.1,6.9-27.5,2.6-34.3-9.5S18.5,27.9,30.6,21s27.5-2.6,34.3,9.5v0C71.8,42.7,67.6,58,55.5,64.9L55.5,64.9L55.5,64.9L55.5,64.9 L55.5,64.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(408.91 151.34)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -374.9401 -98.5139)",
    className: "st1 st2 st3"
  }, "B"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearB);
export default __webpack_public_path__ + "static/media/gear-b.5ebb1ac976325c99601c220f5a505a10.svg";
export { ForwardRef as ReactComponent };